/** Iter 632 — customer wizard · extra-photo strip + collage (moved verbatim from EngageWizardSteps.jsx). */
import React, { useRef } from "react";
import { Loader2 } from "lucide-react";

/**
 * Iter-627 — extra-photo strip + one-tap collage. The collage becomes
 * the main (shared) photo; the previous main moves into the strip.
 * Used on the Photo step (waiting screen) AND the Share step preview.
 */
export default function ExtraPhotosControls({ extraPhotos, onAddExtra, onMakeCollage, collageBusy = false }) {
  const extraRef = useRef(null);
  const readExtra = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    const reader = new FileReader();
    reader.onload = () => {
      const b64 = String(reader.result || "").split(",")[1] || "";
      if (b64) onAddExtra({ b64, previewUrl });
    };
    reader.readAsDataURL(file);
  };
  return (
    <div className="mt-2.5">
      {extraPhotos?.length > 0 && (
        <div className="flex items-center justify-center gap-1.5 flex-wrap" data-testid="engage-photo-strip">
          {extraPhotos.map((p, i) => (
            <img
              key={i}
              src={p.previewUrl}
              alt={`Extra ${i + 1}`}
              className="w-12 h-12 object-cover rounded-lg border border-slate-200"
              data-testid={`engage-extra-photo-${i}`}
            />
          ))}
        </div>
      )}
      <div className="mt-2 flex items-center justify-center gap-2 flex-wrap">
        {(extraPhotos?.length || 0) < 3 && (
          <button
            type="button"
            data-testid="engage-add-extra-photo"
            onClick={() => extraRef.current?.click()}
            className="rounded-full bg-white border border-slate-300 hover:border-slate-500 text-slate-700 text-xs font-bold px-4 py-2 transition-colors"
          >
            ➕ Add another photo
          </button>
        )}
        {extraPhotos?.length >= 1 && onMakeCollage && (
          <button
            type="button"
            data-testid="cust-make-collage"
            disabled={collageBusy}
            onClick={onMakeCollage}
            className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold px-4 py-2 transition-colors disabled:opacity-60"
          >
            {collageBusy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "🧩"} Make a collage of{" "}
            {Math.min(1 + extraPhotos.length, 4)} photos
          </button>
        )}
      </div>
      <input ref={extraRef} type="file" accept="image/*" className="hidden" onChange={readExtra} data-testid="engage-extra-photo-input" />
    </div>
  );
}
